const DisableRightClick = () => {
    document.addEventListener('contextmenu', function (event) {
        // only block right-clicks on images
        if (event.target.closest('img')) {
            event.preventDefault();
        }
    });

    // prevent drag & drop of images
    document.addEventListener('dragstart', function (event) {
        if (event.target.closest('img')) {
            event.preventDefault();
        }
    });
};

export default DisableRightClick;